var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(-366 -607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_34",
    "data-name": "Rect\\xE1ngulo 34",
    width: 18,
    height: 18,
    transform: "translate(366 607)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "air",
    d: "M2.211,5.433c1.076-.924,1.925-1.654,4.231-.351a5.629,5.629,0,0,0,2.744.861,4.29,4.29,0,0,0,2.876-1.351.638.638,0,0,0,.075-.886.608.608,0,0,0-.868-.077c-1.075.925-1.925,1.655-4.231.351-3.047-1.72-4.474-.495-5.621.491a.638.638,0,0,0-.074.886.607.607,0,0,0,.868.076ZM11.27,6.774c-1.075.924-1.925,1.655-4.231.351-3.047-1.721-4.474-.5-5.621.49a.638.638,0,0,0-.074.886.607.607,0,0,0,.868.077c1.076-.924,1.925-1.654,4.231-.352a5.627,5.627,0,0,0,2.744.862,4.287,4.287,0,0,0,2.876-1.352.637.637,0,0,0,.075-.886.607.607,0,0,0-.868-.076Zm0,3.144c-1.075.925-1.925,1.655-4.231.352-3.047-1.721-4.474-.5-5.621.49a.638.638,0,0,0-.074.886.607.607,0,0,0,.868.076c1.076-.924,1.925-1.653,4.231-.351a5.643,5.643,0,0,0,2.744.862,4.294,4.294,0,0,0,2.876-1.352A.638.638,0,0,0,12.138,10a.609.609,0,0,0-.868-.077Z",
    transform: "translate(367.802 607.881)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.f7341917f18ebfc76eb9feb8e65759ae.svg";
export { ForwardRef as ReactComponent };